/**
 * Trip-length helpers for the "short trip" access rule.
 *
 * Non-paid accounts get the full itinerary experience for short trips
 * (date range <= 3 days); longer trips keep the Day-1 teaser + per-feature caps.
 * This must stay in sync with the backend SubscriptionService.is_short_trip.
 */

/**
 * Inclusive trip length in days from a start/end date string ("YYYY-MM-DD").
 * Returns null when either date is missing or unparseable.
 */
export const tripDayCount = (startDate, endDate) => {
  if (!startDate || !endDate) return null;
  const start = new Date(`${startDate}T00:00:00`);
  const end = new Date(`${endDate}T00:00:00`);
  if (isNaN(start.getTime()) || isNaN(end.getTime())) return null;
  const days = Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1;
  return days > 0 ? days : null;
};

/**
 * True when the trip is <= maxDays. Prefers the date range; falls back to a
 * parsed day count (e.g. itineraryDays.length) when dates are missing. Unknown
 * length is treated as NOT short, so gating stays in place for bad data.
 */
export const isShortTrip = (startDate, endDate, fallbackDays = 0, maxDays = 3) => {
  const fromDates = tripDayCount(startDate, endDate);
  const days = fromDates != null ? fromDates : (fallbackDays || 0);
  return days > 0 && days <= maxDays;
};
